<template>
  <div>
    <div class="flex w-800 info">
      <div>剩余金额：</div>
      <div class="real mr-10">{{user.realamount}}</div>
      <el-button type="primary" plain @click.native="recharge">充值</el-button>
    </div>
    <div class="flex w-800 info">
      <div class="flex-1">
        户号：{{user.userno}}
      </div>
      <div class="flex-1">
        用户姓名：{{user.username}}
      </div>
      <div class="flex-1">
        用户地址：{{user.buildnum}}栋 {{user.buildunit}}单元 {{user.buildroom}}室
      </div>
    </div>
    <div class="flex w-800 info">
      <div class="flex-1">
        总用电量：{{user.totalusedp}}
      </div>
      <div class="flex-1">
        累计金额：{{user.sumAmount}}
      </div>
      <div class="flex-1">
        当前电价：{{user.currentStepValue}}
      </div>
    </div>
    <div class="flex w-800 info">
      <div class="flex-1">
        缴费状态：{{globalData.feestate[user.feestate]}}
      </div>
      <div class="flex-1">
        继电器状态：{{globalData.relaystate[user.relaystate]}}
      </div>
      <div class="flex-1">

      </div>
    </div>
    <form-dialog ref="model" title="充值" @on-confirm="save">
      <div slot="dialog-main">
        <el-form v-if="page == 1">
          <el-form-item label="充值金额" label-width="120px">
            <el-input v-model="money"></el-input>
          </el-form-item>
        </el-form>
        <el-form v-if="page == 2">

          <el-form-item label="充值金额" label-width="120px">
            <el-input v-model="money"></el-input>
          </el-form-item>
          <div style="text-align: center;font-size: 14px;line-height: 40px;color: #999">请微信扫码支付！</div>
          <div  id="code" style="width: 256px;height: 256px;margin: auto"></div>
        </el-form>
      </div>
    </form-dialog>


  </div>
</template>
<script>
  import FormDialog from "../../components/FormDialog";
  export default{
    components: {FormDialog},
    data(){
        return{
            user:{},
          money:'',
          page :1,
          order:''
        }
    },
    mounted(){
        this.getInfo()
    },
    methods:{
        getInfo(){
          this.$http$({method: 'get', url: '/smartMeterServer/user/'+this.$store.state.LoginUser.userId},
            (data) => {
              this.user = data
            })
        },
      recharge(){
          this.page = 1
          this.money = ''
          this.$refs.model.show()
      },
      save(){
        this.page = 2
        this.$refs.model.show()
          if(!this.money){
              this.$error('请先输入金额')
            return
          }
        this.$http$({method: 'get', url: '/smartMeterServer/wxPay/prepay/web/'+this.$store.state.LoginUser.userId,data:{money:this.money}},(data) => {
          $('#code').qrcode(data.url)

          this.searchOrderStatus(data.orderNo)
        })
      },
      searchOrderStatus(order){
        this.$http$({method: 'get', url: '/smartMeterServer/PayOrder/'+order},(data) => {
          if(data.status == 3){
            this.$success('充值成功！')
            this.$refs.model.hide()
            this.getInfo()
          }else{
              setTimeout(() => {
                  this.searchOrderStatus(order)
              },5000)
          }
        })
      }
    }
  }
</script>
<style scoped="">
  .w-800{
    width: 800px;
  }
  .info{
    line-height: 40px;
    font-size: 16px;
    color: #333;
  }
  .real{
    font-size: 20px;
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserInfo.vue